import { PropsWithChildren } from "react";
import { useParams, Outlet } from "react-router-dom";

import { BeamlineProvider } from './beamlineProvider.tsx';
import { SampleSetsProvider } from './sampleSetsProvider.tsx';


// The only purpose of this component is to accept a Set slug as a url parameter
// and provide the corredponging ESAF slug to a SampleSetsProvider.
// It's so we can respond to urls like /set/:setSlug, in addition to the more standard
// /esaf/:esafSlug/set/:setSlug.

const SampleSetsFromEsaf: React.FC<PropsWithChildren<{}>> = (props) => {

  let { esafSlug: esafSlugFromParams } = useParams();

  return (
      <BeamlineProvider esafSlug={esafSlugFromParams}>
        <SampleSetsProvider esafSlug={esafSlugFromParams}>
          <Outlet />
        </SampleSetsProvider>
      </BeamlineProvider>
  )
}

export { SampleSetsFromEsaf }